import React from 'react';
import { useTranslation } from 'react-i18next';

function Portfolio({ settings }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const getVal = (keyBs, keyEn, fallback) => {
    if (!settings) return fallback;
    const val = lang === 'en' ? settings[keyEn] : settings[keyBs];
    return val || settings[keyBs] || fallback;
  };

  const title = getVal('portfolioTitleBs', 'portfolioTitleEn', 'Portfolio');
  const subtitle = getVal('portfolioSubtitleBs', 'portfolioSubtitleEn', '');

  const items = [
    {
      title: getVal('portfolioItem1TitleBs', 'portfolioItem1TitleEn', 'Wedding'),
      image: settings?.portfolioItem1Image || '/img/photos/hero1d.jpg',
      isVideo: settings?.portfolioItem1IsVideo || false
    },
    {
      title: getVal('portfolioItem2TitleBs', 'portfolioItem2TitleEn', 'Films'),
      image: settings?.portfolioItem2Image || '/img/photos/hero2d.jpg',
      isVideo: settings?.portfolioItem2IsVideo !== undefined ? settings.portfolioItem2IsVideo : true
    },
    {
      title: getVal('portfolioItem3TitleBs', 'portfolioItem3TitleEn', 'Engagement'),
      image: settings?.portfolioItem3Image || '/img/photos/hero3d.jpg',
      isVideo: settings?.portfolioItem3IsVideo || false
    },
    {
      title: getVal('portfolioItem4TitleBs', 'portfolioItem4TitleEn', 'About me'),
      image: settings?.portfolioItem4Image || '/img/photos/default.jpg',
      isVideo: settings?.portfolioItem4IsVideo || false
    }
  ];

  return (
    <div className="w-full bg-[#fcfaf8] py-16 md:py-32 px-6 md:px-12 lg:px-20 font-sans">
      {/* Portfolio Title */}
      <div className="text-center mb-16 md:mb-24">
        <h2 className="text-5xl md:text-6xl lg:text-7xl font-serif text-gray-900 uppercase tracking-tight">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-6 text-gray-500 max-w-2xl mx-auto text-sm md:text-lg italic font-medium">
            {subtitle}
          </p>
        )}
      </div>

      {/* Portfolio Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 lg:gap-12 max-w-7xl mx-auto">
        
        {items.map((item, idx) => {
          const link = settings?.[`portfolioItem${idx+1}Link`];
          const Wrapper = ({ children }) => link ? <a href={link} className="block">{children}</a> : <div>{children}</div>;
          return (
            <div key={idx} className="group cursor-pointer">
              <Wrapper>
                <h3 className="text-xl md:text-2xl font-serif text-gray-700 mb-4 md:mb-6 transition-colors group-hover:text-black text-center uppercase tracking-wide">
                  {item.title}
                </h3>
                <div className="relative aspect-[3/4] overflow-hidden bg-gray-100 shadow-sm rounded-sm">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-all duration-700 group-hover:scale-105"
                  />
                  {item.isVideo && (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-16 h-16 md:w-20 md:h-20 bg-gray-800/40 backdrop-blur-sm rounded-full flex items-center justify-center transition-all duration-300 group-hover:bg-gray-800/60 group-hover:scale-110 border border-white/20">
                        <svg
                          className="w-6 h-6 md:w-8 md:h-8 text-white ml-1"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
              </Wrapper>
            </div>
          );
        })}

      </div>
    </div>
  );
}

export default Portfolio;
